import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'dva'

import { CONTAINER_IDS } from '../../../../lib/constants'
import { setScrollPosition } from '../../../../lib/utils'
import actions from './actions'
import Eyecon from '../../../Form/Eyecon'
import FeatureContextMenu from './FeatureContextMenu'
import FeatureFilter from './FeatureFilter'
import FeatureListItem from '../../../FeatureListItem'
import FeatureSearch from './FeatureSearch'
import FeatureSelectAll from './FeatureSelectAll'
import GHAnimatedLogo from '../../../../assets/svg/GHAnimatedLogo'
import Loader from '../../../Loader'
import NoUserData from './NoUserData'
import SidebarBody from '../../SidebarBody'
import styles from './SavedContent.module.scss'

function SavedContentTabContent(props) {
  useEffect(() => {
    props.setHasScrollBar(CONTAINER_IDS.sidebarBody)
    if (props.scrollPosition) {
      setScrollPosition(props.scrollPosition)
    }
  }, [props.isLoading, props.isLoadingMoreFeatures])

  return (
    <>
      <div className={styles.headerButtons}>
        <div className={styles.filters}>
          <FeatureSearch />
          <FeatureFilter />
          <FeatureContextMenu />
        </div>
      </div>
      <SidebarBody className={`${styles.bodyContainer} ${props.hasScrollBar && styles.scrollBar}`}>
        <div className={`${styles.listHeader} ${props.isDisabled && styles.disable}`}>
          <div className={styles.listHeaderInfo}>
            {props.isDeselectingItems || props.isSelectingItems ? (
              <div className={styles.loader}>
                <Loader active={true} small={true} />
              </div>
            ) : (
              <FeatureSelectAll />
            )}
          </div>
          <div className={styles.checkboxContainer}>
            <Eyecon isOn={props.anyFeaturesVisible} onChange={v => props.toggleVisibilityAll(v)} />
          </div>
        </div>
        {props.isLoadingMoreFeatures ? (
          <div className={styles.ghLoader}>
            <GHAnimatedLogo width={72} height={108} />
            <p>{props.loaderText}</p>
          </div>
        ) : props.isLoading ? (
          <div className={styles.loader}>
            <Loader active={true} />
            {props.loaderText}
          </div>
        ) : props.featuresList.length > 0 ? (
          props.featuresList.map((fl, i) => {
            return (
              <FeatureListItem
                feature={fl}
                isDisabled={props.isDisabled}
                isSelected={fl.isSelected}
                isVisible={fl.isVisible}
                key={i}
                onClick={() => props.featureClicked(fl)}
              />
            )
          })
        ) : (
          <NoUserData {...props} />
        )}
      </SidebarBody>
    </>
  )
}

SavedContentTabContent.propTypes = {
  allFeaturesSelected: PropTypes.bool,
  anyFeaturesVisible: PropTypes.bool,
  featuresList: PropTypes.array,
  hasScrollBar: PropTypes.bool,
  isDeselectingItems: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isLoadingMoreFeatures: PropTypes.bool,
  isSelectingItems: PropTypes.bool,
  loaderText: PropTypes.string,
  scrollPosition: PropTypes.string,
  selectedFeatures: PropTypes.array,
  // actions
  exportAllContent: PropTypes.func,
  featureClicked: PropTypes.func,
  importContent: PropTypes.func,
  toggleCheckboxAll: PropTypes.func,
  toggleFeatureVisibility: PropTypes.func,
  toggleVisibilityAll: PropTypes.func,
  setHasScrollBar: PropTypes.func
}

export default connect(model => {
  const { app: appModel, features: featureModel } = model
  const { sidebarHasScrollBar, sideBarScrollPosition } = appModel
  const { featuresList, preferences, selectedFeatures } = featureModel
  const { featuresLoading: isLoadingFeatures, moreFeaturesLoading: isLoadingMoreFeatures } = featureModel
  const { isCanceling, isDeletingItems, isDeselectingItems, isEditingFeature, isHidingItems, isSaving, isSelectingItems, isShowingItems, isSortingItems } =
    featureModel
  const hasScrollBar = sidebarHasScrollBar
  const isDisabled = isEditingFeature || isLoading
  const isLoading =
    isHidingItems ||
    isLoadingFeatures ||
    isDeletingItems ||
    isCanceling ||
    isDeselectingItems ||
    isLoadingMoreFeatures ||
    isSaving ||
    isSelectingItems ||
    isShowingItems ||
    isSortingItems
  const scrollPosition = sideBarScrollPosition.features
  let allFeaturesSelected = false
  let anyFeaturesVisible = false
  let loaderText = 'Loading Content...'

  if (!isLoading && featuresList.length > 0) {
    let feature = null
    for (let fli = 0; fli < featuresList.length; fli++) {
      feature = featuresList[fli]
      if (!preferences.visible.features.length) {
        feature.isVisible = preferences.visible.all
      } else {
        feature.isVisible = preferences.visible.features.includes(feature.id)
      }
    }
    allFeaturesSelected = featuresList.length === selectedFeatures.length
    const featureIndex = featuresList.findIndex(fl => fl.isVisible)
    if (featureIndex > -1) anyFeaturesVisible = true
  } else {
    if (isCanceling) {
      loaderText = 'Canceling...'
    } else if (isDeletingItems) {
      loaderText = 'Deleting content...'
    } else if (isSaving) {
      loaderText = 'Saving...'
    } else if (isHidingItems) {
      loaderText = 'Hiding content...'
    } else if (isDeselectingItems) {
      loaderText = 'Deselecting content...'
    } else if (isSelectingItems) {
      loaderText = 'Selecting content...'
    } else if (isShowingItems) {
      loaderText = 'Showing content...'
    } else if (isSortingItems) {
      loaderText = 'Sorting content...'
    }
  }
  return {
    allFeaturesSelected,
    anyFeaturesVisible,
    featuresList,
    hasScrollBar,
    isDeletingItems,
    isDeselectingItems,
    isDisabled,
    isLoading,
    isLoadingMoreFeatures,
    isSelectingItems,
    isSortingItems,
    loaderText,
    scrollPosition,
    selectedFeatures
  }
}, actions)(SavedContentTabContent)
